import { useEffect } from 'react';
import { createContext, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useWebSocket from '../../hooks/useWebSocket2';
import { addMessage, updateSession } from '../../redux/liveChat/slice';
import { selectCurrentChat } from '../../redux/liveChat/selectors';

import { updateMessage } from '../../redux/liveChat/slice';
import toast from 'react-hot-toast';
import LetterNotification from '../customComponents/LetterNotification/LetterNotification';
import { fetchUser } from '../../api/paidUsers';
import {
  addStream,
  removeStream,
  updateStream,
} from '../../redux/videoChat/slice';
import ChatNotification from '../customComponents/ChatNotification/ChatNotification';
import { addOnlineUser, removeOnlineUser } from '../../redux/websocket/slice';
import { updateUserBalance } from '../../redux/auth/slice';
import { fetchAgencyUserById } from '../../api/agencyUsers';
import { selectIsManager } from '../../redux/auth/selectors';

const WebSocketContext = createContext(null);
export const useWebSocketContext = () => useContext(WebSocketContext);

const WebSocketProvider = ({ children }) => {
  const isManager = useSelector(selectIsManager);
  const dispatch = useDispatch();
  const currentChat = useSelector(selectCurrentChat);
  const { socket, sendData, addCallback, isConnected } = useWebSocket();

  useEffect(() => {
    const handleMessage = async message => {
      if (message.chatId === currentChat?._id) {
        dispatch(addMessage(message));
      } else {
        let user;
        const isSupport =
          message.senderType === 'agencyUserSupport' ||
          message.senderType === 'support';
        if (isSupport) {
          user = await fetchAgencyUserById(message.senderId);
        } else {
          user = await fetchUser(message.senderId);
        }
        if (!(isManager && message.senderType === 'paidUserSupport')) {
          toast(
            t => <ChatNotification letter={message} id={t.id} user={user} />,
            {
              duration: 30000, //TODO change duration of notification
              position: 'top-right',
            },
          );
        }
      }

      dispatch(updateSession({ chatId: message.chatId, lastMessage: message }));
    };
    addCallback('sendMessage', handleMessage);
  }, [currentChat, addCallback, dispatch, isManager]);

  useEffect(() => {
    const handleMessage = async message => {
      const user = await fetchUser(message.senderId);

      toast(
        t => <LetterNotification letter={message} id={t.id} user={user} />,
        {
          duration: 30000, //TODO change duration of notification
          position: 'top-right',
        },
      );
    };
    addCallback('newLetter', handleMessage);
  }, [addCallback, dispatch]);

  useEffect(() => {
    const handleUpdateBalance = async data => {
      const { balance } = data;
      dispatch(updateUserBalance(balance));
    };
    addCallback('updateBalance', handleUpdateBalance);
  }, [addCallback, dispatch]);

  useEffect(() => {
    const handleUpdateMessage = message => {
      dispatch(updateMessage(message));
    };
    addCallback('updateMessage', handleUpdateMessage);
  }, [addCallback, dispatch]);

  useEffect(() => {
    const handleAddStream = stream => {
      dispatch(addStream(stream));
    };
    const handleUpdateStream = data => {
      dispatch(updateStream(data));
    };
    const handleRemoveStream = ({ meetingId }) => {
      dispatch(removeStream(meetingId));
    };
    const handleAddOnlineUser = ({ id }) => {
      dispatch(addOnlineUser(id));
    };
    const handleRemoveOnlineUser = ({ id }) => {
      dispatch(removeOnlineUser(id));
    };

    addCallback('createStream', handleAddStream);
    addCallback('updateStream', handleUpdateStream);
    addCallback('removeStream', handleRemoveStream);
    addCallback('addOnlineUser', handleAddOnlineUser);
    addCallback('removeOnlineUser', handleRemoveOnlineUser);
  }, [addCallback, dispatch]);

  return (
    <WebSocketContext.Provider
      value={{ sendData, addCallback, socket, isConnected }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketProvider;
